import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import LoopIcon from "@material-ui/icons/Loop";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import IconDelete from "app/common/Icon/IconDelete";
import {
  format2NumberAtferComma,
  formatMoney,
  getDateTime,
  handleGetQRCodeByValue,
} from "app/common/LocalFunction";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import { FieldArray, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const SelectCardFeePopup = ({
  open,
  handleClose,
  handleSubmit,
  handleInitCardItemsAndServiceItems,
  initialValueCardFee,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <PopupForm
      open={open}
      size="lg"
      // height="75vh"
      handleClose={handleClose}
      title={"Chọn thẻ trả trước"}
      formik={{
        initialValues: initialValueCardFee,
        onSubmit: handleSubmit,
        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" disabled={isSubmitting}>
              {!isMobile && <Save className="mr-2 " />}
              Áp dụng
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              handleInitCardItemsAndServiceItems={
                handleInitCardItemsAndServiceItems
              }
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(({ handleInitCardItemsAndServiceItems }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            style={{ backgroundColor: "aliceblue", marginBottom: "4px" }}
          >
            <Grid item xs={12} sm={6} md={2}>
              <GlobitsPagingAutocomplete
                name={"department"}
                label={"Cơ sở"}
                api={pagingDepartment}
                required
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <GlobitsPagingAutocomplete
                label="Người giao dịch"
                name="accountant"
                displayLabel="staffName"
                api={pagingStaff}
                searchObject={{
                  isActive: true,
                }}
                required
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <div className="summary-box">
                <div className="summary-icon-label">
                  <AttachMoneyIcon className="summary-icon" />
                  <span className="summary-label">
                    Tổng tiền thẻ được dùng:
                  </span>
                </div>
                <span className="summary-value">
                  {formatMoney(values?.cardUsedValue)}
                </span>
              </div>
            </Grid>
            <ListCard />
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <div className="summary-box">
                <div className="summary-icon-label">
                  <AttachMoneyIcon className="summary-icon" />
                  <span className="summary-label">Tổng tiền cần thu:</span>
                </div>
                <span className="summary-value">
                  {formatMoney(values?.moneyAfterDiscount)}
                </span>
              </div>
            </Grid>
            <Grid item xs={12}>
              <TableService />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className="flex justify-end">
          <CommonButton
            className="btn-primary"
            onClick={async () => {
              if (!values?.accountant) {
                toast.warning("Vui lòng chọn người giao dịch!");
                return;
              }
              let data = await handleInitCardItemsAndServiceItems(values);
              setFieldValue("transItems", data?.transItems);
              console.log("data", data);
            }}
          >
            <LoopIcon /> Phân bổ
          </CommonButton>
        </Grid>
        <Grid item xs={12} className="flex justify-end">
          <Items />
        </Grid>
      </Grid>
    </>
  );
});

const Items = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  return (
    <Grid item sm={12}>
      <div
        style={{
          overflow: "auto",
          scrollbarWidth: "thin",
        }}
        className="table-root"
      >
        <div style={{ minWidth: "1000px" }}>
          <table className="table-container table-collapse table-layout-fixed">
            <thead className="row-table-header">
              <tr className="row-table-header">
                <th width="20" align="center">
                  <strong>STT</strong>
                </th>
                <th width="50">
                  <strong>Thẻ</strong>
                </th>
                <th width="80">
                  <strong>Tên dịch vụ</strong>
                </th>

                <th width="50">
                  <strong>Thu hiện thời</strong>
                </th>

                <th width="50">
                  <strong>Trừ thẻ</strong>
                </th>
                <th width="20">
                  <strong>Xóa</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <FieldArray name="transItems">
                {({ remove }) => {
                  return (
                    <>
                      {values?.transItems?.length > 0 ? (
                        <>
                          {values?.transItems?.map((item, itemIndex) => {
                            return (
                              <>
                                <tr key={`item-${itemIndex}`}>
                                  <td align="center">{itemIndex + 1}</td>
                                  <td>
                                    <b className="service-name">
                                      {item?.prepaidCard?.clientCard?.name}
                                    </b>
                                  </td>
                                  <td align="">
                                    <b>{item?.invoiceItem?.invoiceItemName}</b>
                                    <div>
                                      SL: <b>{item?.quantity} *</b>{" "}
                                      {format2NumberAtferComma(
                                        item?.invoiceItem?.currentFee
                                      )}
                                    </div>
                                  </td>

                                  <td align="right">
                                    <b>
                                      {format2NumberAtferComma(
                                        item?.invoiceItem?.currentPaymentAmount
                                      )}
                                    </b>
                                  </td>
                                  <td align="">
                                    <GlobitsVNDCurrencyInput
                                      name={`transItems[${itemIndex}].amount`}
                                    />
                                  </td>
                                  <td align="center">
                                    <span
                                      tooltip={t("delete")}
                                      className="pointer tooltip"
                                      onClick={() => remove(itemIndex)}
                                    >
                                      <IconDelete />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <tr className="row-table-body row-table-no_data">
                          <td colSpan={6} align="center">
                            {t("noData")}
                          </td>
                        </tr>
                      )}
                    </>
                  );
                }}
              </FieldArray>
            </tbody>
          </table>
        </div>
      </div>
    </Grid>
  );
};

const TableService = observer(() => {
  const { listServiceFromFeePopupSelected, listSelectedSv, setListSelectedSv } =
    useStore().feeStore.serviceFeeTabStore;
  console.log("listSelectedSv", listSelectedSv);
  return (
    <TableComponent
      data={listServiceFromFeePopupSelected || []}
      initStateRow={listSelectedSv}
      selectType="multi"
      handleChangeSelectedRows={(selectedItems) =>
        setListSelectedSv(selectedItems)
      }
      align="center"
      columns={[
        {
          field: "stt",
          title: "STT",
          align: "center",
          with: "50px",
          render: (row, index) => <span>{index + 1}</span>,
        },

        {
          field: "invoiceItemName",
          title: "Tên dịch vụ",
          render: (row) => (
            <span className="service-name">{row?.invoiceItemName}</span>
          ),
        },
        {
          field: "remaining",
          title: "Cần trả",
          render: (row) => (
            <span className="service-name">
              {formatMoney(row?.subAmountActuallyPaid)}
            </span>
          ),
        },
      ]}
    />
  );
});

const ListCard = observer(() => {
  const { pageCardFee, setListSelectedCard, listSelectedCard } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <TableComponent
      data={pageCardFee?.content || []}
      initStateRow={listSelectedCard}
      selectType="multi"
      handleChangeSelectedRows={(selectedItems) =>
        setListSelectedCard(selectedItems)
      }
      align="center"
      columns={[
        {
          field: "stt",
          title: "STT",
          align: "center",
          with: "50px",
          render: (row, index) => <span>{index + 1}</span>,
        },
        {
          field: "code",
          title: "Mã đơn hàng"
        },
        {
          field: "clientCard.code",
          title: "Mã thẻ",
          render: (val) => {
            return (
              <div>
                <span className="service-code">{val?.clientCard?.code}</span>
              </div>
            );
          },
        },
        {
          field: "clientCard.name",
          title: "Tên thẻ",
          render: (val) => (
            <div>
              <span className="service-name">{val?.clientCard?.name}</span>
            </div>
          ),
        },
        {
          field: "quantity",
          title: "Số lượng",
          align: "right",
        },
        {
          field: "totalValue",
          title: "Giá trị sử dụng",
          render: (val) => formatMoney(val?.totalValue),
        },
        {
          field: "totalUsed",
          title: "Giá trị đã sử dụng",
          render: (val) => formatMoney(val?.totalUsed),
        },
        {
          field: "clientCard.name",
          title: "Ngày đăng ký",
          render: (val) => getDateTime(val?.startDate),
        },
      ]}
    />
  );
});
// const ListCard = observer(() => {
//   const { pageCardFee, setListSelectedCard, listSelectedCard } =
//     useStore().patientManagementStore.feeStore;

//   return (
//     <>
//       {pageCardFee?.content?.map((el, index) => (
//         <Grid item xs={12}>
//           <CreditCard
//             card={el}
//             setListSelectedCard={setListSelectedCard}
//             listSelectedCard={listSelectedCard}
//           />
//         </Grid>
//       ))}
//     </>
//   );
// });
const CreditCard = observer(({ card, checked }) => {
  const [qr, setQr] = useState(null);

  useEffect(() => {
    const fetchQrCode = async () => {
      try {
        const qrCode = await handleGetQRCodeByValue(card?.clientCard?.code);
        setQr(qrCode);
      } catch (error) {
        console.error("Failed to fetch QR code:", error);
      }
    };

    if (card?.id) {
      fetchQrCode();
    }
  }, [card?.clientCard?.id]);

  return (
    <article
      className={`payment-card ${checked ? "checked" : ""}`}
      style={{ backgroundColor: "#422369" }}
    >
      <input
        type="checkbox"
        // checked={checked}
        // onChange={onChange}
        className="payment-card__checkbox"
        style={{
          position: "absolute",
          top: "12px",
          left: "12px",
          width: "20px",
          height: "20px",
          zIndex: 10,
        }}
      />
      <img
        src="https://sondnpt00343.github.io/f8-project-08/assets/img/card/plane-bg.svg"
        alt=""
        class="payment-card__img"
      />
      <div class="payment-card__top flex-end">
        <img
          src="
        https://thammylinhanh.vn/wp-content/uploads/2024/11/logo-Tham-my-Quoc-te-Linh-Anh.jpg
        "
          alt=""
          className="payment-card__logo"
        />
      </div>
      <div class="payment-card__number">
        <div>{card?.code}</div>
        <span class="payment-card__name">{card?.clientCard?.name}</span>
      </div>
      <div class="payment-card__bottom justify-between align-center">
        <div>
          <p class="payment-card__label">Giá trị</p>
          <p class="payment-card__value">
            {formatMoney(card?.clientCard.totalPrice * card?.quantity)}
          </p>
        </div>

        {/* <div class="payment-card__circle"></div> */}
        <div className="payment-card__gift">
          <img src={qr} alt="" />
        </div>
      </div>
    </article>
  );
});

export default memo(observer(SelectCardFeePopup));
